/**
 * 图片保护工具 - 禁止右键保存和拖拽
 */

/**
 * 初始化图片保护功能
 * 禁用图片的右键菜单和拖拽功能
 */
export const initImageProtection = () => {
  // 禁用图片右键菜单
  document.addEventListener('contextmenu', (e) => {
    const target = e.target as HTMLElement;
    if (target.tagName === 'IMG' || target.tagName === 'CANVAS') {
      e.preventDefault();
      return false;
    }
  });

  // 禁用图片拖拽
  document.addEventListener('dragstart', (e) => {
    const target = e.target as HTMLElement;
    if (target.tagName === 'IMG' || target.tagName === 'CANVAS') {
      e.preventDefault();
      return false;
    }
  });

  // 添加 CSS 样式禁用选择和拖拽
  const style = document.createElement('style');
  style.textContent = `
    img, canvas {
      user-select: none;
      -webkit-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      -webkit-user-drag: none;
      -khtml-user-drag: none;
      -moz-user-drag: none;
      -o-user-drag: none;
      pointer-events: auto;
    }
  `;
  document.head.appendChild(style);
};

/**
 * 移除图片保护功能（如果需要）
 */
export const removeImageProtection = () => {
  // 注意：这个函数只是示例，实际上移除事件监听器需要保存引用
  console.log('⚠️ 图片保护已禁用');
};

